import formatProductsData from './format-products-data-shopify';
import fieldsRequest from './fields-request';
import loadProductsByCollection from '../../core/storefrontAPI/load-products-by-collection';

/*
This fallback class is used to handle Shopify collections in case Nosto data has issues
Important: also update the NostoCollections class in collections.js if editing this one
*/
export default class ShopifyCollection {
  collection_id;
  fields;

  constructor(collection_id) {
    this.collection_id = collection_id;
    this.fields = fieldsRequest;

    window.theme.collections.filtering = [];
    window.theme.collections.sorting = 'manual';
  }

  // Convert the filter data into the needed format for Shopify Storefront API
  transformFilters = (filters) => {
    // to do...

    return filters;
  };

  /**
   * Make Shopify Storefront API request
   * Doesn't apply to search overlay
   * 
   * @returns {Promise} Formatted products data
   */
  shopifyRequest = async () => {
    try {
      let filters = [];
      if (typeof window.theme.collections?.filtering !== 'undefined' && window.theme.collections?.filtering.length) {
        filters = window.theme.collections.filtering;
      }

      // Enforce plus size-only products on plus size collections
      if (document.querySelector('[data-collection-grid]')?.dataset?.plus === 'true') {
        filters.push(['skus.customFields.astr-plus_size', 'true']);
      }

      console.log('[ASTR] filters 1', filters);
      filters = (filters.length > 0) ? this.transformFilters(filters) : [];

      // Hide ambassaor products if not on the ambassador collection
      // Hide ambassaor products on the ambassador collection but the user is not an ambassador (in case someone hacks the redirect from the collection page)
      if ((window.theme.collections.current === 'ambassador' && !window.theme.customer.ambassador) || window.theme.collections.current !== 'ambassador') {
        filters.push({
          'not': [
            { 'field': 'tags1', 'value': ['AMBASSADOR', 'Ambassador', 'ambassador'] }
          ]
        });
      }

      console.log('[ASTR] filters 2', filters);
      console.log('[ASTR] products_per_page: ', window.theme.collections.products_per_page, ' page: ', window.theme.collections.page);

      // const from_page = (Number(window.theme.collections.products_per_page) * (window.theme.collections.page - 1)) ?? 0;
      
      const response = await loadProductsByCollection(window.theme.collections.current_id, '');

      return formatProductsData(response);
    } catch (error) {
      console.log('ShopifyCollection Error', error);
      return [];
    }
  };
}
